import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-524dcd45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node-summary" }
const _hoisted_2 = { class: "node-summary-title color-purple" }
const _hoisted_3 = { class: "node-summary-branch-name color-purple" }
const _hoisted_4 = {
  key: 0,
  class: "node-summary-otherwise color-dark-gray"
}
const _hoisted_5 = { class: "node-summary-title color-purple" }
const _hoisted_6 = {
  key: 0,
  class: "node-summary-statement color-dark-gray"
}
const _hoisted_7 = {
  key: 1,
  class: "node-summary-grid"
}
const _hoisted_8 = { class: "node-summary-label" }
const _hoisted_9 = { class: "node-summary-cell" }
const _hoisted_10 = {
  key: 0,
  class: "node-summary-aside"
}
const _hoisted_11 = {
  key: 0,
  class: "node-summary-chip color-dark-gray"
}
const _hoisted_12 = {
  key: 1,
  class: "node-summary-chip color-dark-gray"
}
const _hoisted_13 = { class: "node-summary-title color-purple" }
const _hoisted_14 = { class: "node-summary-grid" }
const _hoisted_15 = { class: "node-summary-col" }
const _hoisted_16 = { class: "node-summary-col" }
const _hoisted_17 = { class: "node-summary-label" }
const _hoisted_18 = {
  key: 0,
  class: "node-summary-kind color-dark-gray"
}
const _hoisted_19 = { class: "node-summary-cell" }

import { computed } from "vue";
import i18n from "@/core/i18n/i18n";
import NodeConditionRows from "@/flow/components/vue-flow/NodeConditionRows.vue";
import {
  displayValueClass as valueClass,
  isLoopStep,
  isRouterStep,
  summarizeLoop,
  summarizeRouterBranches,
  summarizeStepDelay,
  summarizeStepFilter,
  summarizeStepInputs,
} from "@/flow/utils/stepInputSummary";

interface IProps {
  step: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeInputSummary',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = i18n.global;

const isRouter = computed(() => isRouterStep(props.step));
const isLoop = computed(() => isLoopStep(props.step));
const rows = computed(() => summarizeStepInputs(props.step));
const loopRows = computed(() => summarizeLoop(props.step));
const loopTypeRow = computed(() =>
  loopRows.value.find((row) => row.translateValue)
);
const loopValueRows = computed(() =>
  loopRows.value.filter((row) => !row.translateValue && !row.labelKey)
);
const loopLabelledRows = computed(() =>
  loopRows.value.filter((row) => !row.translateValue && row.labelKey)
);
const branches = computed(() => summarizeRouterBranches(props.step));
const hasDelay = computed(() => summarizeStepDelay(props.step) !== null);
const hasFilter = computed(() => summarizeStepFilter(props.step).length > 0);
const title = computed(() => {
  if (isRouter.value) {
    return t("Flow.BranchConditions");
  }
  return isLoop.value ? t("Common.LoopSettings") : t("Flow.StepInputs");
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isRouter.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branches.value, (branch, branchIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `branch-${branchIndex}`,
              class: "node-summary-branch"
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(branch.name || `${_unref(t)("Common.Condition")} ${branchIndex + 1}`), 1),
              (branch.isDefault)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("Flow.BranchOtherwise")), 1))
                : _createCommentVNode("", true),
              _createVNode(NodeConditionRows, {
                rows: branch.rows
              }, null, 8, ["rows"])
            ]))
          }), 128))
        ], 64))
      : (isLoop.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(title.value), 1),
            (loopTypeRow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)(loopTypeRow.value.display.text)), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopValueRows.value, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `loop-value-${index}`,
                class: "node-summary-cell"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_unref(valueClass)(row.display))
                }, _toDisplayString(row.display.text), 3)
              ]))
            }), 128)),
            (loopLabelledRows.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopLabelledRows.value, (row, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `loop-${index}`
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)(row.labelKey)), 1),
                      _createElementVNode("span", _hoisted_9, [
                        _createElementVNode("span", {
                          class: _normalizeClass(_unref(valueClass)(row.display))
                        }, _toDisplayString(row.display.text), 3)
                      ])
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (hasDelay.value || hasFilter.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (hasDelay.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_font_awesome_icon, { icon: "hourglass-start" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.StepDelay")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (hasFilter.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createVNode(_component_font_awesome_icon, { icon: "filter" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.StepFilter")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, _toDisplayString(title.value), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("Common.Name")), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("Common.Value")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `input-${index}`
                }, [
                  _createElementVNode("span", _hoisted_17, [
                    _createTextVNode(_toDisplayString(row.label) + " ", 1),
                    (row.kind === 'header')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(t)("Flow.InputKindHeader")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_unref(valueClass)(row.display))
                    }, _toDisplayString(row.display.text), 3)
                  ])
                ], 64))
              }), 128))
            ])
          ], 64))
  ]))
}
}

})